import { atomFamily } from "recoil";

import { IExtendableDto } from "../../dto";
import { StarredDisplayModeEnum, UserEditDisplayModeEnum } from "../../enums";
import { sessionStorageHelpers } from "../../helpers";
import { ITypeormWhereCriteria, RideEntity, RydeUiUnit } from "../../models";

export const tableRowsAtomFamily = atomFamily<
  IExtendableDto[] | undefined,
  RydeUiUnit
>({
  key: "tableRowsAtomFamily",
  default: [],
});

export const tableRowsCountAtomFamily = atomFamily<number, RydeUiUnit>({
  key: "tableRowsCountAtomFamily",
  default: 0,
});

export const selectedTableRowsIdsAtomFamily = atomFamily<number[], RydeUiUnit>({
  key: "selectedTableRowsIdsAtomFamily",
  default: [],
});

export const selectedTableRowsIncrementAtomFamily = atomFamily<
  number,
  RydeUiUnit
>({
  key: "selectedTableRowsIncrementAtomFamily",
  default: 0,
});

export const lastSearchCriteriaAtomFamily = atomFamily<
  ITypeormWhereCriteria<RideEntity | IExtendableDto> | undefined,
  RydeUiUnit
>({
  key: "lastSearchCriteriaAtomFamily",
  default: undefined,
});

export const lastAppliedSearchCriteriaAF = atomFamily<
  Record<string, unknown> | undefined,
  RydeUiUnit
>({
  key: "lastAppliedSearchCriteriaAF",
  default: undefined,
});

export const starredTableRowsIdsAtomFamily = atomFamily<number[], RydeUiUnit>({
  key: "starredTableRowsIdsAtomFamily",
  default: unit => sessionStorageHelpers.getItem(`starred_ids_${unit}`) || [],
});

export const starredDisplayModeAtomFamily = atomFamily<
  StarredDisplayModeEnum,
  RydeUiUnit
>({
  key: "starredDisplayModeAtomFamily",
  default: StarredDisplayModeEnum.ShowAllIncludeStarred,
});

export const highlightedAfterEditAtomFamily = atomFamily<number[], RydeUiUnit>({
  key: "highlightedAfterEditAtomFamily",
  default: [],
});

export const isNeedToFetchTableRowsAF = atomFamily<boolean, RydeUiUnit>({
  key: "isNeedToFetchTableRows",
  default: false,
});

export const userEditOnlyDisplayModeAtomFamily = atomFamily<
  UserEditDisplayModeEnum,
  RydeUiUnit
>({
  key: "userEditOnlyDisplayModeAtomFamily",
  default: UserEditDisplayModeEnum.AllRides,
});

export const nearByFilterAtomFamily = atomFamily<boolean, RydeUiUnit>({
  key: "nearByFilterAtomFamily",
  default: false,
});

export const showSelectedOnlyRowsAtomFamily = atomFamily<boolean, RydeUiUnit>({
  key: "showSelectedOnlyRowsAtomFamily",
  default: false,
});

/** Live map grid: when true, only rows with at least one New incident (see `computedData.newIncidentsCount`). */
export const showOnlyRidesWithNewIncidentsAtomFamily = atomFamily<
  boolean,
  RydeUiUnit
>({
  key: "showOnlyRidesWithNewIncidentsAtomFamily",
  default: false,
});
